import { Services } from '@sigma-frontend-libs/commons'

import { permissionPresets } from '@/utils'

import render from './render'

export default {
  name: 'Item',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    canGetPaymentsAsAdmin() {
      return this.checkPermissions(`advanced.${Services.payments}.get`)
    },
    canGetUsersAsResellerUp() {
      return this.checkPermissions(`advanced.${Services.users}.get`, permissionPresets.resellerUp)
    },

    currency() {
      return this.value.currency || this.globalSettings.billings.currency
    }
  },

  render
}
